import * as React from 'react';
import { SelectDropdown } from '../../../../internal/components/SelectDropdown';
import styles from './styles.module.css';
import { GroupedSelectDesktopOptions } from '../GroupedSelectDesktopOptions';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function GroupedSelectDesktopDropdown(props) {
  var open = props.open,
    value = props.value,
    groups = props.groups,
    focusedIndex = props.focusedIndex,
    actions = props.actions,
    onKeyDown = props.onKeyDown,
    insideRefs = props.insideRefs;
  return /*#__PURE__*/_jsx(SelectDropdown, {
    onClose: actions.closeDropdown,
    insideRefs: insideRefs,
    children: /*#__PURE__*/_jsx("div", {
      className: styles['list'],
      role: "listbox",
      onKeyDown: onKeyDown,
      children: groups.map(function (group, index) {
        var key = group.key,
          label = group.label,
          leftAdornment = group.leftAdornment,
          options = group.options;
        return /*#__PURE__*/_jsxs("div", {
          className: styles['group-wrapper'],
          children: [/*#__PURE__*/_jsx("div", {
            className: styles['group-label'],
            children: /*#__PURE__*/_jsxs("div", {
              className: styles['group'],
              children: [!!leftAdornment && /*#__PURE__*/_jsx("div", {
                className: styles['icon'],
                children: leftAdornment
              }), /*#__PURE__*/_jsx("div", {
                className: styles['label'],
                children: label
              })]
            })
          }), /*#__PURE__*/_jsx(GroupedSelectDesktopOptions, {
            open: open,
            indented: !!leftAdornment,
            groupIndex: index,
            options: options,
            value: value,
            focusedIndex: focusedIndex,
            actions: actions
          })]
        }, key);
      })
    })
  });
}